// Export utilities for analytics data

export const exportToCSV = (data, filename = 'analytics-data.csv') => {
  if (!data || data.length === 0) {
    console.warn('No data to export');
    return;
  }

  // Convert data to CSV format
  const headers = Object.keys(data[0]);
  const csvContent = [
    headers.join(','),
    ...data.map(row => 
      headers.map(header => {
        const value = row[header];
        // Escape commas and quotes
        if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
          return `"${value.replace(/"/g, '""')}"`;
        }
        return value;
      }).join(',')
    )
  ].join('\n');

  // Create and download file
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const exportToJSON = (data, filename = 'analytics-data.json') => {
  if (!data) {
    console.warn('No data to export');
    return;
  }

  const jsonContent = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonContent], { type: 'application/json' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const formatDateForExport = (date) => {
  if (!date) return '';
  const d = new Date(date);
  return d.toISOString().split('T')[0];
};

export const formatDurationForExport = (seconds) => {
  if (!seconds) return '0:00';
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
};

export const prepareCallDataForExport = (calls) => {
  return calls.map(call => ({
    'Call ID': call.id || '',
    'Agent': call.agentName || '',
    'Phone Number': call.phoneNumber || '',
    'Status': call.status || '',
    'Duration': formatDurationForExport(call.duration),
    'Start Time': formatDateForExport(call.startTime),
    'End Time': formatDateForExport(call.endTime),
    'Outcome': call.outcome || '',
    'Reason': call.reason || '',
    'Cost': call.cost || 0
  }));
};

export const prepareAnalyticsDataForExport = (analytics) => {
  return {
    summary: {
      'Total Calls': analytics.totalCalls || 0,
      'Completed Calls': analytics.completedCalls || 0,
      'Failed Calls': analytics.failedCalls || 0,
      'Total Duration': formatDurationForExport(analytics.totalDuration),
      'Average Duration': formatDurationForExport(analytics.averageDuration),
      'Success Rate': `${analytics.successRate || 0}%`,
      'Total Cost': `$${(analytics.totalCost || 0).toFixed(2)}`
    },
    trends: analytics.trends || [],
    reasons: analytics.reasons || [],
    agentPerformance: analytics.agentPerformance || []
  };
}; 